export const PRODUCT_NAME = "Axios Digital Screen";
export const PRODUCT_MONOGRAM = "ADS";
export const PRODUCT_CATEGORY = "Interactive directory, wayfinding, and digital signage platform";
export const COMPANY_NAME = "Axios Software";
export const COMPANY_LEGAL_NAME = "Axios Software Inc.";
export const PRODUCT_SURFACES = Object.freeze({
    console: "Operations | Axios Digital Screen",
    help: "Help Center | Axios Digital Screen",
    player: "Axios Digital Screen Player",
    portal: "Portal | Axios Digital Screen",
    status: "Status | Axios Digital Screen",
});
export const BRAND_COLORS = Object.freeze({
    border: "#e0ddd8",
    ink: "#211e1b",
    live: "#08a5b8",
    primary: "#206691",
    reversed: "#f3f1ee",
    secondary: "#6e6860",
    surface: "#f7f6f4",
});
/**
 * Safe fallback identity for public kiosk experiences when a tenant has not
 * configured its own branding. Both colors maintain at least 4.5:1 contrast
 * against white because kiosk controls render white labels on these tokens.
 */
export const PUBLIC_EXPERIENCE_BRAND_DEFAULTS = Object.freeze({
    accentColor: "#087f8c",
    displayName: PRODUCT_NAME,
    primaryColor: BRAND_COLORS.primary,
});
export const BRAND_MARK_GEOMETRY = Object.freeze({
    framePath: "M25 48H15a5 5 0 0 1-5-5V19a5 5 0 0 1 5-5h34a5 5 0 0 1 5 5v24a5 5 0 0 1-5 5H39",
    node: Object.freeze({ cx: 32, cy: 48, radius: 5 }),
    strokeWidth: 5,
    viewBox: "0 0 64 64",
});
export function brandMarkPalette(variant = "color") {
    switch (variant) {
        case "monochrome":
            return Object.freeze({ frame: BRAND_COLORS.ink, node: BRAND_COLORS.ink });
        case "reversed":
            return Object.freeze({
                frame: BRAND_COLORS.reversed,
                node: BRAND_COLORS.live,
            });
        case "reversed-monochrome":
            return Object.freeze({
                frame: BRAND_COLORS.reversed,
                node: BRAND_COLORS.reversed,
            });
        case "color":
            return Object.freeze({ frame: BRAND_COLORS.ink, node: BRAND_COLORS.live });
    }
}
function escapeXml(value) {
    return value
        .replaceAll("&", "&amp;")
        .replaceAll('"', "&quot;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;");
}
export function renderBrandMarkSvg({ accessibleName, variant = "color", } = {}) {
    const palette = brandMarkPalette(variant);
    const accessibility = accessibleName
        ? `role="img" aria-label="${escapeXml(accessibleName)}"`
        : 'aria-hidden="true" focusable="false"';
    return [
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${BRAND_MARK_GEOMETRY.viewBox}" ${accessibility}>`,
        `<path d="${BRAND_MARK_GEOMETRY.framePath}" fill="none" stroke="${palette.frame}" stroke-linecap="round" stroke-linejoin="round" stroke-width="${BRAND_MARK_GEOMETRY.strokeWidth}"/>`,
        `<circle cx="${BRAND_MARK_GEOMETRY.node.cx}" cy="${BRAND_MARK_GEOMETRY.node.cy}" r="${BRAND_MARK_GEOMETRY.node.radius}" fill="${palette.node}"/>`,
        "</svg>",
    ].join("");
}
//# sourceMappingURL=index.js.map